import { Stack } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { Restricted } from '@procureai/permissions-ui';

import { SearchAiSwitch } from '../SearchAiSwitch/SearchAiSwitch.tsx';
import { SearchAutocompleteHeadless } from '../SearchAutocompleteHeadless/SearchAutocompleteHeadless.tsx';
import { SearchDomain } from '~/routes/Search/types/SearchDomain.ts';

export interface SearchBarProps {
  domain?: SearchDomain;
}

export const SearchBar = ({ domain }: SearchBarProps) => {
  return (
    <Stack
      direction="row"
      sx={{
        columnGap: 4,
        paddingTop: 3,
        paddingBottom: 4,
      }}
    >
      <SearchAutocompleteHeadless domain={domain} />
      <Restricted needs={{ permission: Permission.SearchUseAi }}>
        <SearchAiSwitch />
      </Restricted>
    </Stack>
  );
};
